export class ErrorService {
  public throwError(error: unknown): Error {
    let errorMessage: string;

    if (error instanceof Error) {
      errorMessage = `Error: ${error.name} - ${error.message}`;
    } else if (typeof error === 'string') {
      errorMessage = error;
    } else {
      errorMessage = String(error);
    }

    return new Error(errorMessage);
  }
}
